import React from 'react';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom'
import classNames from 'classnames';
import classes from './Menu.scss';
import config from 'cityads-v3/config';
import { useTheme } from '@mui/material'

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';

import Tooltip from 'cityads-v3/components/Tooltip/Tooltip';
import UserdocsLink from 'cityads-v3/components/Links/UserdocsLink';

import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import InsertDriveFileOutlinedIcon from '@mui/icons-material/InsertDriveFileOutlined';
import { RootState } from 'cityads-v3/types/reducer';

export default function MenuBottomLinks(): JSX.Element {
  const { t } = useTranslation(['main'])
  const docked = useSelector((state: RootState) => state.menu.docked)
  const isMobile = useSelector((state: RootState) => state.app.isMobile)
  const isBlogger = useSelector((state: RootState) => state.auth.user?.isBlogger)

  const theme = useTheme()
  const isDark = theme.palette.mode === 'dark';

  if (isBlogger) {
    return null
  }

  return (
    <div className={classes.bottomLinks}>
      <List dense={true}>

        <Tooltip
          isLight
          enabled={!docked}
          enterDelay={config.TOOLTIP_DELAY}
          title={t('documentation')}
          disableFocusListener={true}
          placement="right"
        >
          <ListItem sx={{ p: 0 }}>
            <ListItemButton
              component={UserdocsLink}
              href={'/'}
            >
              <ListItemIcon
                sx={{
                  margin: !docked && !isMobile ? 'auto' : '0',
                  minWidth: 'initial',
                  marginRight: docked && !isMobile ? '0.75em' : 'auto',
                }}
              >
                <InfoOutlinedIcon />
              </ListItemIcon>
              {(docked || isMobile) && <ListItemText
                primary={t('documentation')}
                classes={{
                  root: classes.itemTextTop,
                  primary: classNames(classes.itemTextPrimaryTop, {
                    [classes.isDark]: isDark
                  }),
                }}
              />}
            </ListItemButton>
          </ListItem>
        </Tooltip>
        <Tooltip
          isLight
          enabled={!docked}
          enterDelay={config.TOOLTIP_DELAY}
          title={t('documentationApi')}
          disableFocusListener={true}
          placement="right"
        >
          <ListItem sx={{ p: 0 }}>
            <ListItemButton
              component={Link}
              to="/publisher/api/description"
            >
              <ListItemIcon
                sx={{
                  margin: !docked && !isMobile ? 'auto' : '0',
                  minWidth: 'initial',
                  marginRight: docked && !isMobile ? '0.75em' : 'auto',
                }}
              >
                <InsertDriveFileOutlinedIcon />
              </ListItemIcon>
              {(docked || isMobile) && <ListItemText
                primary={t('documentationApi')}
                classes={{
                  root: classes.itemTextTop,
                  primary: classNames(classes.itemTextPrimaryTop, {
                    [classes.isDark]: isDark
                  }),
                }}
              />}
            </ListItemButton>
          </ListItem>
        </Tooltip>
      </List>
    </div>
  )
}
